<template>
  <div v-if="showing" class="scd-overlay" @click.self="cancel()">
    <div class="scd-modal">
      <div class="scd-modal__head">
        <span>Filter</span>
        <button class="scd-close" @click="cancel()"><i class="fal fa-times"></i></button>
      </div>

      <div class="scd-modal__body">
        <div class="scd-field">
          <label class="scd-label">Search</label>
          <input
            v-model="internalFilters.search"
            type="text"
            class="scd-select"
            placeholder="Search campaigns..."
            @keyup.enter="save()"
          />
        </div>

        <div class="scd-field" v-if="businessAutocomelete">
          <label class="scd-label">Business</label>
          <business-autocomplete
            v-model="internalFilters.business_uuid"
            :return-object="false"
          ></business-autocomplete>
        </div>

        <div class="scd-field">
          <label class="scd-label">Compensation</label>
          <select v-model="internalFilters.commission_type" class="scd-select">
            <option :value="null">Any</option>
            <option v-for="opt in commissionTypes" :key="opt.value" :value="opt.value">{{ opt.text }}</option>
          </select>
        </div>

        <div class="scd-field">
          <follower-select v-model="internalFilters.min_followers"></follower-select>
        </div>

        <div class="scd-field">
          <channel-category-select
            v-model="internalFilters.category_ids"
            :return-object="false"
          ></channel-category-select>
        </div>
      </div>

      <div class="scd-modal__foot">
        <button class="scd-btn" @click="cancel()">Undo</button>
        <button class="scd-btn scd-btn--primary" @click="save()">Apply</button>
      </div>
    </div>
  </div>
</template>
<script>
import FollowerSelect from "../../selects/FollowerSelect";
import ChannelCategorySelect from "../../selects/ChannelCategorySelect";
import BusinessAutocomplete from "../../autocompletes/BusinessAutocomplete";

export default {
  components: { ChannelCategorySelect, FollowerSelect, BusinessAutocomplete },
  props: {
    value: {
      type: Boolean,
      required: false,
      default: false
    },
    filters: {
      required: true,
      type: Object
    },
    businessAutocomelete: {
      required: false,
      default: false
    }
  },
  data: () => ({
    dialog: false,
    internalFilters: null,
    commissionTypes: [
      {text: 'Compensation per click', value: 'click'},
      {text: 'Compensation per per sale', value: 'conversion'},
      {text: 'Compensation per lead', value: 'lead'}
    ]
  }),
  computed: {
    showing: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  watch: {
    filters: {
      immediate: true,
      deep: true,
      handler(newVal) {
        this.internalFilters = this.cloneDeep(newVal);
      }
    },
    showing() {
      this.internalFilters = this.cloneDeep(this.filters);
    }
  },
  methods: {
    save() {
      const params = ["min_cost_per_action_percent",  "business_uuid", "search", "min_cost_per_action_fixed"]
      if (
         "category_ids" in this.internalFilters &&
         this.internalFilters["category_ids"].length === 0
      ) {
        delete this.internalFilters["category_ids"];
      }
      params.forEach(param => {
        if (
           param in this.internalFilters &&
           this.internalFilters[param] === null
        ) {
          delete this.internalFilters[param];
        }
      });
      this.$emit("save", this.cloneDeep(this.internalFilters));
      this.showing = false;
    },
    cancel() {
      this.$emit("cancel");
      this.showing = false;
    }
  }
};
</script>